import React from 'react'
import TextInput from '../../components/FormElements/TextInput'
import { FieldValues, useForm } from 'react-hook-form'
import { ReactComponent as Logo } from './../../images/logo_vertical_colored.svg'
import { Button } from '@demandlocal/components'
import PrimaryButton from '../../components/Buttons/PrimaryButton'
import { useNavigate, useParams } from 'react-router'
import { useAuthResetPassword } from '../../api/auth/useAuthResetPassword'
import { ReactComponent as Check } from './../../images/icons/check_fill.svg'
import { AnimatePresence, motion } from 'framer-motion'
const AuthReset = (): JSX.Element => {
  const { token } = useParams()
  const navigate = useNavigate()
  const {
    control,
    handleSubmit,
    formState: { isSubmitting, isSubmitSuccessful },
  } = useForm({
    mode: 'onSubmit',
  })

  const { mutateAsync: authGenerateResetToken } = useAuthResetPassword()

  const onSubmit = async (data: Partial<FieldValues>): Promise<void> => {
    if (token) {
      await authGenerateResetToken({
        password: data.password,
        token,
      })
    } else {
      throw new Error('No token found')
    }
  }

  return (
    <div className={'h-screen flex justify-center'}>
      <div className={'w-full max-w-xl mx-auto my-auto'}>
        <motion.div layout className={'flex justify-center p-10'}>
          <Logo className={'h-32'} />
        </motion.div>
        <motion.div layout className={'w-full p-10 rounded-lg bg-cultured-gray'}>
          <AnimatePresence mode={'popLayout'}>
            <motion.div>
              {!isSubmitSuccessful && (
                <motion.div
                  layout
                  exit={{
                    opacity: 0,
                  }}
                  transition={{
                    type: 'spring',
                    stiffness: 350,
                    damping: 25,
                  }}>
                  <div className={'font-Spartan font-bold text-xl'}>
                    Reset your password
                  </div>
                  <form onSubmit={handleSubmit(onSubmit)}>
                    <div className={'pt-8'}>
                      <TextInput
                        rules={{ required: 'This field is required' }}
                        name={'password'}
                        label={'Password'}
                        type={'password'}
                        control={control}
                      />
                      <TextInput
                        rules={{ required: 'This field is required' }}
                        name={'confirm_password'}
                        label={'Confirm password'}
                        type={'password'}
                        control={control}
                      />
                    </div>
                    <div className={'pt-8'}>
                      <Button disabled={isSubmitting} type={'submit'}>
                        Reset password
                      </Button>
                    </div>
                  </form>
                </motion.div>
              )}
              {isSubmitSuccessful && (
                <motion.div
                  initial={{
                    scale: 0,
                    opacity: 0.5,
                  }}
                  animate={{
                    opacity: 1,
                    scale: 1,
                  }}
                  transition={{
                    type: 'spring',
                    stiffness: 350,
                    damping: 50,
                  }}
                  className={'flex flex-col items-center'}>
                  <motion.div
                    className={'w-20 h-20 rounded-full flex justify-center items-center'}>
                    <Check />
                  </motion.div>
                  <div className={'font-Spartan font-bold text-center pt-8 text-xl'}>
                    Your password has been reset
                  </div>
                  <motion.div
                    initial={{
                      y: 50,
                      opacity: 0,
                    }}
                    animate={{
                      y: 0,
                      opacity: 1,
                    }}
                    transition={{
                      type: 'spring',
                      stiffness: 350,
                      damping: 50,
                      delay: 0.8,
                    }}
                    className={'pt-8'}>
                    <Button
                      variant={'primary'}
                      onClick={() => {
                        navigate('/auth/login')
                      }}>
                      Go to login
                    </Button>
                  </motion.div>
                </motion.div>
              )}
            </motion.div>
          </AnimatePresence>
        </motion.div>
      </div>
    </div>
  )
}

export default AuthReset
